"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, type ReactNode } from "react";
import { advanceAuthScopeGeneration, captureAuthScope } from "@/lib/auth/authScopeGeneration";
import { connectorOAuthCoordinator } from "@/lib/oauth/connectorOAuthCoordinator";
import { PluginAuthScopeSync } from "@/components/plugins/PluginAuthScopeSync";

/**
 * Sole owner of auth-generation advances for connector OAuth and plugin fetches.
 * Advances on login, logout, user-identity change, and provider teardown.
 */
export function ConnectorOAuthCoordinatorProvider(t0) {
  const $ = _c(10);
  const {
    authenticated,
    authScopeKey,
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] !== authScopeKey || $[1] !== authenticated) {
    t1 = () => {
      if (authenticated && authScopeKey) {
        advanceAuthScopeGeneration(authScopeKey);
        const scope = captureAuthScope(authScopeKey);
        if (scope) {
          connectorOAuthCoordinator.activate(scope);
        }
      } else {
        if (authScopeKey) {
          advanceAuthScopeGeneration(authScopeKey);
        }
        connectorOAuthCoordinator.deactivate();
      }
    };
    t2 = [authenticated, authScopeKey];
    $[0] = authScopeKey;
    $[1] = authenticated;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== authScopeKey) {
    t3 = () => () => {
      if (authScopeKey) {
        advanceAuthScopeGeneration(authScopeKey);
      }
      connectorOAuthCoordinator.deactivate();
    };
    t4 = [authScopeKey];
    $[4] = authScopeKey;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PluginAuthScopeSync />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children) {
    t6 = <>{t5}{children}</>;
    $[8] = children;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}